import { px2rem } from '../utils/helpers/style.js';

/**
 * This is an auto generated file - do not modify manually!
 * Fonts are fetched via Figma api
 */
var defaultLevelFontSizes = [{
  "default": px2rem(32),
  s: px2rem(46),
  l: px2rem(58)
}, {
  "default": px2rem(29),
  s: px2rem(41),
  l: px2rem(46)
}, {
  "default": px2rem(26),
  s: px2rem(36),
  l: px2rem(41)
}, {
  "default": px2rem(23),
  s: px2rem(29),
  l: px2rem(36)
}, {
  "default": px2rem(20),
  s: px2rem(26),
  l: px2rem(29)
}];
var defaultLevelFontSizesNumerical = [{
  "default": 32,
  s: 46,
  l: 58
}, {
  "default": 29,
  s: 41,
  l: 46
}, {
  "default": 26,
  s: 36,
  l: 41
}, {
  "default": 23,
  s: 29,
  l: 36
}, {
  "default": 20,
  s: 26,
  l: 29
}];

export { defaultLevelFontSizes, defaultLevelFontSizesNumerical };
